export default {
  authorization: "authorization",
  cancel: "Cancel",
  delete: "Delete",
  wear: "Wear",
  healthy: "Healthy",
  warning: "Warning",
  rating: "Rating",
  submit: "Submit",
  architecture: "Architecture",
  create: "Create",
  dashboard: "Dashboard",
  edited: "Edited",
  model: "Model",
  current: "Current",
  name: "Name",
  version: "Version",
  installed: "Installed",
  todos: "Todos",
  created: "Created",
  pendingActions: "Pending Actions",
  createdBy: "Created by",
  noAssetAssigned: "No Asset Assigned",
  modified: "Modified",
  loading: "Loading...",
  versions: "Versions",
  vulnerabilities: "Vulnerabilities",
  released: "Released",
  asset: "Asset",
  type: "Type",
  details: "Details",
  installedOn: "Installed on",
  alerts: "Alerts",
  confirmationOfOrder: "Confirmation of Order",
  feature: "Feature",
  equipment: "Equipment",
  select: "Select",
  description: "Description",
  noDescription: "No Description",
  administrator: "Administrator",
  digger: "Digger",
  yearOfConstruction: "Year of Construction",
  yearOfProduction: "Year of Production",
  confirm: "Confirm",
  edit: "Edit",
  typeOf: "Type of",
  event: "Event",
  continue: "Continue",
  assignedTo: "Assigned to",
  noAssignment: "No Assignment",
  machine: "Machine",
  media: "Media",
  deliveryNote: "Delivery Note",
  tenant: "Tenant",
  scheduler: "Scheduler",
  productArea: "Product Area",
  productDivision: "Product Division",
  productGroup: "Product Group",
  productLine: "Product Line",
  productFamily: "Product Family",
  productModel: "Product Model",
  productCategory: "Product Category",
  wheelLoader: "Wheel Loader",
  invoice: "Invoice",
  crawler: "Crawler",
  quickChanger: "Quick Changer",
  weldingBadge: "Welding Badge",
  save: "Save",
  listOfParts: "List of Parts",
  towerPiece: "Tower Piece",
  next: "Next",
  previous: "Previous",
  yes: "Yes",
  no: "No",
  back: "Back",
  assign: "Assign",
  rentalAgreement: "rental agreement",
  reset: "Reset",
  topSlewingCranes: "top slewing cranes",
  OK: "OK",
  field: "Field",
  key: "Key",
  value: "Value",
  all: "All",
  user: "User",
  paired: "Paired",
  notPaired: "Not Paired",
  receiver: "Receiver",
  list: "List",
  rest: "Rest",
  interval: "Interval",
  state: "State",
  coupling: "Coupling",
  never: "never",
  optional: "Optional",
  good: "Good",
  critical: "Critical",
  unknown: "Unknown",
  noAsset: "No Asset Assigned",
  upToDate: "Up to date",
  pending: "Pending",
  filterByRating: "Filter by Rating",
  logs: "Logs",
  search: "Search",
  resetPassword: "Reset Password",
  tags: "Tags",
  tag: "Tag",
  refresh: "Refresh",
  service: "Service",
  hash: "Hash",
  status: "Status",
};
